module.exports = __webpack_public_path__ + "img/close.441258e7.svg";